<nav class='navbar navbar-expand-lg navbar-light bg-light'>
  <span>
    <a class='navbar-brand' href='/'>Masterprice</a>
    Worldwide selling price calculation
  </span>
</nav>
<p-confirmDialog></p-confirmDialog>
<p-toast position='top-center'></p-toast>
  <div class='upload-file manage'>
    <ng-container>
      <div *ngIf='isLoading' class='download-wait'>
        <h1>Loading...</h1>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div *ngIf='isDeleting' class='download-wait'>
        <h1>Deleting item constraint...</h1>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div *ngIf='isUpdating' class='download-wait'>
        <h1>Updating item constraint...</h1>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <app-modal *ngIf="isModalExportConstraintOpen" (close)="isModalExportConstraintOpen = false">
        <app-export-constraint></app-export-constraint>
      </app-modal>
      <app-modal *ngIf="isModalAddConstraintOpen" (close)="isModalAddConstraintOpen = false">
        <app-add-constraint></app-add-constraint>
      </app-modal>
      <div>
        <h4 class='upload-title'>Manage items constraints</h4>
        <h5 class='upload-subtitle'>This page will allow you to manage items constraints</h5>
        <div class='manage-constraint'>
          <button class="p-button-raised p-button-info mr-2 button-to-upload" pButton
                  pRipple type='button' (click)="openExportConstraintModal()"
                  *appUserCan="['SAVE_MULTIPLE_PRICE_USING_SUPPORT_UI']; operation 'OR'">Export item constraint</button>
          <button class="p-button-raised p-button-info mr-2 button-to-upload" pButton
                  pRipple type='button' (click)="openAddConstraintModal()"
                  *appUserCan="['SAVE_MULTIPLE_PRICE_USING_SUPPORT_UI']; operation 'OR'">Add item constraint</button>
      </div>
        <div>
          <br/>
        </div>
        <ng-container>
          <p-table (onLazyLoad)='refreshFromTab($event)' [filters]='filters'
                   [globalFilterFields]="['code']"
                   [lazy]='true'
                   [paginator]='true'
                   [rowsPerPageOptions]='[5,20, 50, 100]'
                   [rows]='20'
                   [showCurrentPageReport]='true'
                   [showFirstLastIcon]='false'
                   [tableStyle]="{ 'min-height': '300px' }"
                   [totalRecords]='totalItemConstraints'
                   [value]='itemConstraints'
                   currentPageReportTemplate='Showing {first} to {last} of {totalRecords} entries'>
            <ng-template pTemplate='header'>
              <tr>
                <th class='idItemConstraint'>Id</th>
                <th class='code'>Code</th>
                <th class='tierCode'>Geo area</th>
                <th class='user'>User</th>
                <th class='startDate'>Start date</th>
                <th class='endDate'>End date</th>
                <th class='itemConstraintType'>Type</th>
                <th>Action</th>
              </tr>
              <tr>
                <th>
                  <p-columnFilter [ngModel]='idItemConstraint' [showMenu]=false class='filter' field='idItemConstraint' type='text'>
                    <small></small></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter [ngModel]='code' [showMenu]=false class='filter' field='code' type='text'>
                    <small></small></p-columnFilter>
                </th>
                <th>
                </th>
                <th>
                  <p-columnFilter [ngModel]='userId' [showMenu]=false class='filter' field='user' type='text'>
                    <small>{{userId}}</small></p-columnFilter>
                </th>
                <th>
                </th>
                <th>
                </th>
                <th>
                  <p-columnFilter [showMenu]='false' field='itemConstraintTypes' matchMode='in'>
                  <ng-template let-filter='filterCallback' let-value pTemplate='filter'>
                    <p-dropdown (onChange)='filter($event.value)' [ngModel]="itemConstraintType"
                                [options]='availableItemConstraintTypes' [showClear]='false'>
                    </p-dropdown>
                  </ng-template>
                  </p-columnFilter>
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template let-lineItem pTemplate='body'>
              <tr>
                <td class='id center'>{{lineItem.id_item_constraint}}</td>
              <td class='center'>{{lineItem.code}}</td>
                <td class="center">
                  <p-tag *ngIf="lineItem.tier_type" [severity]="(lineItem | geoarea).severity">
                    {{ (lineItem | geoarea).label }}
                  </p-tag>
                </td>
                <td class=' center'>{{humanReadableDate(lineItem.creation_date)}}<br/> by {{ lineItem.created_by | maskUser }}</td>
                <td class='center'>{{humanReadableDate(lineItem.start_date)}}<br/>
                  <small *ngIf='isBeforeNow(lineItem.start_date)' class='date-info started-info'>started</small></td>
                <td class='center'>{{humanReadableDate(lineItem.end_date)}}<br/>
                  <small *ngIf='isBeforeNow(lineItem.end_date)' class='date-info ended-info'>ended</small></td>
                <td class='center'>{{lineItem.item_constraint_type}}</td>
                <td>
                  <p-button
                    *ngIf="getButtonProperties(lineItem)"
                    [label]="getButtonProperties(lineItem)?.label"
                    [styleClass]="getButtonProperties(lineItem)?.styleClass"
                    (click)="getButtonProperties(lineItem)?.clickHandler()">
                  </p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
      </div>

      <div class='home'>
        <p-button icon='pi pi-home' label='Home' routerLink='' styleClass='back p-button-secondary'></p-button>
      </div>
    </ng-container>
  </div>

